import React from 'react'
import { Box, Button, Divider, Stack } from '@mui/material';
import LabelTxt from './LabelTxt';
import { formatDateWithJs, formatUserType } from '../utils/format';


function ComProjCard({ i, width, handleRmvClick, type, cardType }) {
    const typoHeadStyle = {
        borderColor: "rgb(0,0,0,0.1)", fontSize: 12, color: "rgb(0,0,0,0.4)", display: "inline-block",
        width: 110
    }
    const typostyle = { fontSize: 12, display: "inline-block", width: 250 };
    return (
        <Box border={1} borderColor="rgba(0,0,0,0.1)" px={2} py={1} mt={1} width={width ?? "95%"} borderRadius={3} sx={{ position: "relative" }}>
            <Stack direction={"column"} width={"100%"} >
                {cardType === "amtc" && <Stack direction={"row"} justifyContent={"space-between"} width={"100%"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, }}>
                        <LabelTxt typoname={"Company Name"} typodetail={`${i?.comName}`}
                            overflow={35} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                </Stack>}
                <Box border={0.3} borderColor="rgba(0,0,0,0.05)" width={"95%"} marginLeft={2} my={0.3} />
                <Stack direction={"row"} justifyContent={"space-between"} width={"100%"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, }}>
                        <LabelTxt typoname={"Project Name"} typodetail={`${i?.projName} (${i?.actProjIdStrg})`}
                            overflow={35} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ flexShrink: 0, mr: 2, ml: 0.5 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <LabelTxt typoname={"Role"} typodetail={formatUserType(i?.userType)} overflow={50} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                </Stack>
                <Box border={0.3} borderColor="rgba(0,0,0,0.05)" width={"95%"} marginLeft={2} my={0.3} />
                <Stack direction={"row"} justifyContent={"space-between"} >
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, }}>
                        <LabelTxt typoname={"Site Location"} typodetail={i?.siteLocation} overflow={25} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ flexShrink: 0, mr: 2, ml: 0.5 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <LabelTxt typoname={"Assigned Date"} typodetail={formatDateWithJs(i?.startDate)} overflow={25} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                </Stack>
                <Box border={0.3} borderColor="rgba(0,0,0,0.05)" width={"95%"} marginLeft={2} my={0.3} />
                <Stack direction={"row"} justifyContent={"space-between"} >
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, }}>
                        <LabelTxt typoname={"Department"} typodetail={i?.deptName ?? "-"} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ flexShrink: 0, mr: 2, ml: 0.5 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <LabelTxt typoname={"End Date"} typodetail={i?.endDate ? formatDateWithJs(i?.endDate) : "-"} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Box>
                </Stack>
            </Stack>
            {type === "curr" && <Button variant='contained' onClick={() => handleRmvClick(i)} sx={{
                fontSize: 12, position: "absolute", top: -7, right: 0,
                color: "white", bgcolor: "red", height: 22
            }}>
                Remove</Button>}
        </Box>
    );
}
export default ComProjCard;